import config from "../utils/config";
import anchor from "../utils/anchor";
import breakpointChecker from "../utils/breakpointChecker";

export default () => {
  (function ($) {
    $(document).ready(function () {
      anchor();
      if ($(".page--AGI").length === 0) {
        if (config.investor === "wholesale") {
          $(".inv__link").eq(0).addClass("active");
          $(".navPanel__inv").eq(0).addClass("active");
        } else {
          $(".inv__link").eq(1).addClass("active");
          $(".navPanel__inv").eq(1).addClass("active");
        }
        if (config.lang === "en") {
          $(".lang__link").eq(0).addClass("active");
          $(".navPanel__misc").eq(0).addClass("active");
        } else if (config.lang === "tc") {
          $(".lang__link").eq(1).addClass("active");
          $(".navPanel__misc").eq(1).addClass("active");
        } else if (config.lang === "sc") {
          $(".lang__link").eq(2).addClass("active");
          $(".navPanel__misc").eq(2).addClass("active");
        }
      } else {
        // fix media tagging sometime not fired
        // $('a[data-url]').on('click', function(e) {
        //   var url = $(this).attr('data-url')
        //   setTimeout(function() {
        //     location.href = url
        //   }, 300)
        // })
      }

      const videoStyle = function () {
        $(".kv__video, .kv__image").height(function () {
          return Math.min(
            $(window).height() * 0.95,
            Math.max($(".kv__video video, .kv__image img").outerHeight(), 800)
          );
        });
        $(".kv__video video").width(function () {
          return Math.max(
            ($(".kv__media").height() * 640) / 360,
            $(".kv__media").width()
          );
        });
      };

      const mouseWheel = function (e) {
        const evt = window.event || e;
        const delta = evt.detail ? evt.detail * -50 : evt.wheelDelta;
        clearTimeout($.data(this, "scrollTimer"));
        if ($(window).scrollTop() > 50) {
          if (delta / 50 > 0) {
            // up
            $("header").css("opacity", 1);
          } else {
            // down
            $.data(
              this,
              "scrollTimer",
              setTimeout(function () {
                // do something
                if (
                  $(window).scrollTop() -
                    $(".goToTop").position().top +
                    $(window).height() >=
                  $(window).height() * 0.1
                ) {
                  //reach div.goToTop
                  $("header").css("opacity", 0);
                } else {
                  $("header").css("opacity", 0);
                }
              }, 0)
            );
          }
        } else {
          $("header").css("opacity", 1);
        }
      };

      const onClickMobileLangButton = function (e) {
        $(".langToggle__list").toggle();
        $(this).toggleClass("active");
      };

      var lastY = $(window).scrollTop();
      $(window).bind("touchmove", function (e) {
        if (
          $(window).scrollTop() > 50 &&
          $("body").is(".enabledFullPanel") === false
        ) {
          var currentY = $(window).scrollTop();
          if (currentY > lastY) {
            // moved down
            $("header").css("opacity", 0);
          } else if (currentY < lastY) {
            // moved up
            $("header").css("opacity", 1);
          }
          lastY = currentY;
        } else {
          $("header").css("opacity", 1);
        }
      });

      $(window).on("scroll", function () {
        var currentY = $(window).scrollTop();
        if ($(window).scrollTop() > 10) {
          $(".header__main").css({
            height: "75px",
            background: "#fffdf9",
          });
        } else {
          $(".header__main").attr("style", "");
          if ($(window).width() < 992) {
            $("header").css("opacity", 1);
          }
        }
        if (currentY > lastY) {
          $(".header__top").css({
            height: 0,
            overflow: "hidden",
          });
          if ($(window).width() >= 992) {
            $(".logo").css("transform", "scale(0.77)");
          }
          if ($(".page--entry").length > 0) {
            $(".langToggle").show();
          }
        } else {
          $(".header__top").attr("style", "");
          $(".header__main").css("height", "");
          $(".logo").attr("style", "");
          $(".langToggle").hide();
        }
        if ($(window).width() < 992) {
          $(".langToggle").show();
        }
        lastY = currentY;
      });

      const mousewheelevt = /Firefox/i.test(navigator.userAgent)
        ? "DOMMouseScroll"
        : "mousewheel"; //FF doesn't recognize mousewheel as of FF3.x

      $(".langToggle button").on("click", onClickMobileLangButton);
      $(".langToggle__list a").on("click", function () {
        $(".langToggle__list").hide();
        $(".langToggle button").removeClass("active");
      });

      const BPChecker = new breakpointChecker({
        mediaQuery: "(min-width:992px)",
        onMatch: function () {
          $("main.main").attr("style", "");
          $("header").css("opacity", 1);
          videoStyle();
          $(window).on("resize", videoStyle);
          $(window).off(mousewheelevt, mouseWheel);
          setTimeout(function () {
            $(window).trigger("scroll");
          }, 0);
        },
        onDifferent: function () {
          $("main.main").css({
            paddingTop: "90px",
          });
          $(".kv__video, .kv__image").height("auto");
          $(".kv__video video").attr("style", "");
          $(window).off("resize", videoStyle);
          $(window).on(mousewheelevt, mouseWheel);
          setTimeout(function () {
            $(window).trigger("scroll");
          }, 0);
        },
      });
      window.Sharer.init({
        callbackAPI: `layout`,
      });
    });
  })(window.hsvmJQuery);
};
